import Config from './dashboard.router';
import options from './dashboard.component';

require('./dashboards.png'); // eslint-disable-line

const Component = {
    selector: 'dtDashboard',
    options
};

export {
    Config,
    Component
};



// WEBPACK FOOTER //
// ./app/components/dashboard/index.js